import auth from './auth.json';
import budgets from './budgets.json';
import crud from './crud.json';
import daysOff from './daysOff.json';
import entities from './entities.json';
import entityFields from './entityFields';
import headerLinks from './headerLinks.json';
import hoursOverview from './hoursOverview.json';
import importing from './importing.json';
import logHours from './logHours.json';
import menu from './menu.json';
import messages from './messages.json';
import notFound from './notFound.json';
import project from './project.json';
import quickSetup from './quickSetup.json';
import simpleProject from './simpleProject.json';
import strings from './strings.json';
import tenants from './tenants.json';
import userCategories from './userCategories.json';
import users from './users.json';

export default {
  auth,
  budgets,
  crud,
  daysOff,
  entities,
  entityFields,
  headerLinks,
  hoursOverview,
  importing,
  logHours,
  menu,
  messages,
  notFound,
  project,
  quickSetup,
  simpleProject,
  strings,
  tenants,
  userCategories,
  users,
};
